<template>
    <v-dialog v-model="show" max-width="800px">
        <v-card max-width="800">
            <v-btn class="btnClose" icon absolute right dark @click="show = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-img v-if="src.length > 0" contain max-height="200" :src="src" class="xs4 md3 lg2 mt-3"/>
            <v-img v-else max-height="200px" min-height="200px">
                <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"/>
                </v-row>
            </v-img>
            <v-card-title>{{ details.title }}</v-card-title>
            <v-card-text>
                <v-row>
                    <span v-html="details.about"/>
                </v-row>
                <v-divider v-if="details.about.length > 0" class="mx-4 mt-3 mb-4"></v-divider>
                <v-row>
                    <span v-html="details.specs"></span>
                </v-row>
                <v-divider class="mx-4 mt-3 mb-4"></v-divider>
                <v-row align-content="center" justify="center">
                    <v-icon @click="download" large>mdi-arrow-down-bold-box-outline</v-icon>
                </v-row>
            </v-card-text>
        </v-card>
        <download-choice ref="downloadChoice" v-on:close="this.show = false"/>
    </v-dialog>
</template>

<script>
import downloadChoice from "@/components/downloadChoice";

export default {
    name: "detailTorrent",
    components: {downloadChoice},
    data() {
        return {
            src: '',
            show: false,
            details: {title: '', about: ''},
            overlay: false
        }
    },
    methods: {
        download() {
            this.$refs.downloadChoice.open(this.details.id, 'top')
        },
        getDetail(id) {
            this.src = ''
            this.details = {title: '', about: ''}
            this.show = this.overlay = true
            this.$http.get('/getDetail/' + id).then(async (details) => {
                this.details = details.data
                if (details.data.img.indexOf('http') === -1) {
                    await this.image(details.data.img)
                } else {
                    this.src = details.data.img
                }
                this.overlay = false
            })
        },
        async image(route) {
            await this.$http.post('/getTopImage', {route: route}, {
                responseType: 'blob'
            }).then((resp) => {
                let reader = new FileReader()
                reader.readAsDataURL(resp.data)
                reader.onload = () => {
                    this.src = reader.result
                }
            })
        }
    },
    created() {

    }
}
</script>

<style scoped>
.btnClose {
    z-index: 9999;
}
</style>